import React from 'react';
import {
  Accordion as AccordionWrap,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const Accordion = ({ items }) => (
  <AccordionWrap allowZeroExpanded={true}>
    {items.map((item) => (
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {item.title}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="text" dangerouslySetInnerHTML={{__html: item.data}} />
        </AccordionItemPanel>
      </AccordionItem>
    ))}
  </AccordionWrap>
);

export default Accordion;
